'use client';

import React from 'react';
import styles from './styles/LearningGoals.module.css';
export default function LearningGoals({ teacher, user, content, onEditLearningGoals }) {
  return (
    <section className={styles.courseDetailsSection}>
      <h2 className={styles.title}>What You Will Learn</h2>
      <div className={styles.content}>
        <p className={styles.paragraph}>{content}</p>
      </div>
      <div className={styles.editSection}>
        {user?.role === 'ADMIN' ||
        user?.role === 'SUPER_ADMIN' ||
        (user?.role === 'TEACHER' && teacher?.id === user.id) ? (
          <button className={`${styles.btn} ${styles.editBtn}`} onClick={onEditLearningGoals}>
            Edit Learning Goals
          </button>
        ) : null}
      </div>
    </section>
  );
}